import createIcon from '../../createIcon';

/**
 * @component @name ElectricCar
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTguOTIgMi4wMUMxOC43MiAxLjQyIDE4LjE2IDEgMTcuNSAxSDYuNUM1Ljg0IDEgNS4yOSAxLjQyIDUuMDggMi4wMUwzIDhWMTZDMyAxNi41NSAzLjQ1IDE3IDQgMTdINUM1LjU1IDE3IDYgMTYuNTUgNiAxNlYxNUgxOFYxNkMxOCAxNi41NSAxOC40NSAxNyAxOSAxN0gyMEMyMC41NSAxNyAyMSAxNi41NSAyMSAxNlY4TDE4LjkyIDIuMDFaTTYuNSAxMkM1LjY3IDEyIDUgMTEuMzMgNSAxMC41QzUgOS42NyA1LjY3IDkgNi41IDlDNy4zMyA5IDggOS42NyA4IDEwLjVDOCAxMS4zMyA3LjMzIDEyIDYuNSAxMlpNMTcuNSAxMkMxNi42NyAxMiAxNiAxMS4zMyAxNiAxMC41QzE2IDkuNjcgMTYuNjcgOSAxNy41IDlDMTguMzMgOSAxOSA5LjY3IDE5IDEwLjVDMTkgMTEuMzMgMTguMzMgMTIgMTcuNSAxMlpNNSA3TDYuNSAyLjVIMTcuNUwxOSA3SDVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNNyAyMEgxMVYxOEwxNyAyMUgxM1YyM0w3IDIwWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ElectricCar = createIcon('ElectricCar', [
  [
    'path',
    {
      d: 'M18.92 2.01C18.72 1.42 18.16 1 17.5 1H6.5C5.84 1 5.29 1.42 5.08 2.01L3 8V16C3 16.55 3.45 17 4 17H5C5.55 17 6 16.55 6 16V15H18V16C18 16.55 18.45 17 19 17H20C20.55 17 21 16.55 21 16V8L18.92 2.01ZM6.5 12C5.67 12 5 11.33 5 10.5C5 9.67 5.67 9 6.5 9C7.33 9 8 9.67 8 10.5C8 11.33 7.33 12 6.5 12ZM17.5 12C16.67 12 16 11.33 16 10.5C16 9.67 16.67 9 17.5 9C18.33 9 19 9.67 19 10.5C19 11.33 18.33 12 17.5 12ZM5 7L6.5 2.5H17.5L19 7H5Z',
      key: '1vhy97',
    },
  ],
  ['path', { d: 'M7 20H11V18L17 21H13V23L7 20Z', key: '11z7li' }],
]);

export default ElectricCar;
